<template>
  <v-chip
    :small="small"
    :color="color"
  >
    {{ name }}
  </v-chip>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
  },
}
</script>